import React from 'react';
import { Link } from 'react-router-dom';
import { LanguageSwitcher } from './LanguageSwitcher';

const LOGO_URL = 'https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,fit=crop,q=95/A3Qr2BKPp9ixwqK2/captura-de-pantalla-2024-02-22-a-la-s-11.25.21-a.a-m.-m6LrZ28lv4IwWGMQ.png';

export const ClientHeader = () => {
  return (
    <header
      className="sticky top-0 z-40"
      style={{ backgroundColor: 'rgb(40, 37, 92)' }}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between min-h-[68px] px-5 py-3 sm:min-h-[80px] sm:px-10 sm:py-4">
        <Link to="/" className="flex-shrink-0">
          <img
            src={LOGO_URL}
            alt="Sam's Transfer"
            className="w-auto h-[46px] sm:h-[56px] object-contain"
            style={{ background: 'transparent' }}
          />
        </Link>
        <LanguageSwitcher />
      </div>
    </header>
  );
};
